export default __webpack_public_path__ + "static/media/prestige.b3c1db29.png";